import { Dispatch, SetStateAction, useCallback, useDebugValue, useMemo, useState } from 'react';
import isEqual from 'react-fast-compare';

function useFormState<S>(initialState: S | (() => S)): [S, Dispatch<SetStateAction<S>>, boolean, Dispatch<SetStateAction<S>>];
function useFormState<S = undefined>(): [S | undefined, Dispatch<SetStateAction<S | undefined>>, boolean, Dispatch<SetStateAction<S | undefined>>];

function useFormState(initialState?: unknown): unknown {
  const [originalState, setOriginalState] = useState<unknown>(initialState);
  const [state, setState] = useState<unknown>(initialState);

  const isDirty = useMemo(
    () => !isEqual(originalState, state),
    [state, originalState],
  );

  const resetState = useCallback(
    (newState?: unknown) => {
      setOriginalState(newState);
      setState(newState);
    },
    [setOriginalState, setState],
  );

  useDebugValue({ hasChanges: isDirty });

  return [state, setState, isDirty, resetState];
}

export default useFormState;